// D-122: paying Adyvance on Fonepay's own page (hosted checkout). Before the browser leaves, the page
// it was on is remembered; Fonepay sends it back to /_hooks/ady-pay/return/fonepay_web, which checks the
// payment with Fonepay and redirects to `/?ady_payment=<id>`. On that load (main.tsx) the admin moves
// back to the remembered page and the shell shows the result.
import type { AdyPayStart } from "@ady/contracts";

const BACK = "ady.payReturn.back";
const RESULT = "ady.payReturn.result";
const PAYMENT = /^apy_[0-9A-HJKMNP-TV-Z]{26}$/;

/** Sends the browser to Fonepay's page (the start's `next` must be a redirect). */
export function goToFonepay(start: AdyPayStart): void {
  if (start.next.kind !== "redirect") return;
  try {
    sessionStorage.setItem(BACK, window.location.pathname + window.location.search);
  } catch {
    // storage blocked: the shop lands on the admin's start page instead
  }
  window.location.assign(start.next.url);
}

/**
 * On page load: when Fonepay just sent the browser back, keeps the payment to show and returns the
 * page to go back to (null = not a return, or nothing remembered).
 */
export function takeFonepayReturn(): string | null {
  const url = new URL(window.location.href);
  const id = url.searchParams.get("ady_payment");
  if (!id) return null;
  try {
    sessionStorage.setItem(RESULT, PAYMENT.test(id) ? id : "unknown");
    const back = sessionStorage.getItem(BACK);
    sessionStorage.removeItem(BACK);
    if (back && back.startsWith("/") && !back.startsWith("//")) return back;
  } catch {
    // storage blocked: no result popup
  }
  url.searchParams.delete("ady_payment");
  return url.pathname + url.search;
}

/** The payment the shell should show (or "unknown"), until `clearFonepayResult`. */
export function fonepayResult(): string | null {
  try {
    return sessionStorage.getItem(RESULT);
  } catch {
    return null;
  }
}

/** The result was seen (its popup closed). */
export function clearFonepayResult(): void {
  try {
    sessionStorage.removeItem(RESULT);
  } catch {
    // nothing kept
  }
}
